import React from "react";

import { ProfilePic } from "../ProfilePic";

import styles from "./TextArea.scss";

interface UserProfile {
  jobTitle: string;
}

interface TextAreaMentionSuggestionProps {
  id: string;
  name: React.ReactNode;
  userProfile: UserProfile;
}

export function TextAreaMentionSuggestion({
  id,
  name,
  userProfile,
}: TextAreaMentionSuggestionProps) {
  return (
    <React.Fragment key={id}>
      <ProfilePic
        size="medium"
        user={userProfile}
        className={styles["suggestion-pic"]}
      />
      <div
        data-testid="mention-suggestion"
        className={styles["suggestion-info"]}
      >
        {name}
        <span className={styles["suggestion-info__title"]}>
          {userProfile.jobTitle}
        </span>
      </div>
    </React.Fragment>
  );
}
